import React from 'react';
import { PoolManagement } from '../../components/pots';

const PoolsManagement = () => {
  return <PoolManagement />;
};

export default PoolsManagement;
